import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Toast {
  id: number;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

@Injectable({
  providedIn: 'root',
})
export class ToasterService {
  private toastsSubject = new BehaviorSubject<Toast[]>([]);
  private idCounter = 0;

  getToasts(): Observable<Toast[]> {
    return this.toastsSubject.asObservable();
  }

  showToast(message: string, type: Toast['type'] = 'info'): void {
    const newToast: Toast = {
      id: ++this.idCounter,
      message,
      type,
    };
    this.toastsSubject.next([...this.toastsSubject.value, newToast]);
    setTimeout(() => this.removeToast(newToast.id), 5000); // auto-dismiss after 5s
  }

  removeToast(id: number): void {
    const updated = this.toastsSubject.value.filter(toast => toast.id !== id);
    this.toastsSubject.next(updated);
  }
}
